module.exports = __webpack_public_path__ + "img/product_122.06a2246.svg";